var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2075 19.1064L20.2061 20.0778C19.2547 21.0292 18.093 21.5099 16.7511 21.4998C13.7668 21.4698 10.6023 18.9061 8.86977 17.2537L6.74671 15.1307C5.08432 13.3982 2.53064 10.2336 2.5006 7.24934C2.48057 5.9074 2.96126 4.74573 3.91263 3.79436L4.89405 2.79292C5.28461 2.40236 5.91552 2.40236 6.31609 2.79292L10.1817 6.78867C10.5722 7.17924 10.5722 7.82016 10.1817 8.21072L8.02856 10.524L10.2317 12.7272L11.6538 14.1493L13.4764 15.9619L15.7897 13.8088C16.1803 13.4182 16.8212 13.4182 17.2118 13.8088L21.2075 17.6944C21.5981 18.0849 21.5981 18.7158 21.2075 19.1064Z",
    fill: "#4A7628"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSolid);
export default __webpack_public_path__ + "static/media/phone-solid.2904fad852d7c887fe9e82da23e2d595.svg";
export { ForwardRef as ReactComponent };